// extracted by mini-css-extract-plugin
export default {"desktopNav":"Navigation_desktopNav__ZBfjO","navList":"Navigation_navList__sPaTt","menuButton":"Navigation_menuButton__v9MH3"};